import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-column">
          <h4>ABOUT</h4>
          <ul>
            <li>
              <Link to="/contact" onClick={toTop}>
                Contact
              </Link>
            </li>

            <li>
              <Link to="/about" onClick={toTop}>
                Our Story
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>CUSTOMER CARE</h4>
          <ul>
            <li>
              <Link to="/shipping" onClick={toTop}>
                Shipping
              </Link>
            </li>
            <li>
              <Link to="/returns" onClick={toTop}>
                Returns & Exchanges
              </Link>
            </li>
            <li>
              <Link to="/privacy" onClick={toTop}>
                Privacy Policy
              </Link>
            </li>
            <li><Link to="/cookies" onClick={toTop}>Cookie Policy</Link></li>
            <li><Link to="/faqs" onClick={toTop}>FAQs</Link></li>
          </ul>
        </div>

        <div className="footer-column support">
          <h4>CUSTOMER SUPPORT</h4>
          <p>
            <a href="mailto:import@cewillowmarket.life">
              import@cewillowmarket.life
            </a>
          </p>
          <address className="footer-address">
            Hong Kong Mousheng Tech Limited<br />
            FLAT 1506, 15/F, CHEUNG FUNG COMM BLDG,<br />
            21-25 CHEUNG SHA WAN ROAD,<br />
            SHAM SHUI PO, HONG KONG
          </address>
          <div className="footer-payments" aria-label="Supported payment methods">
            <span>VISA</span><span>Mastercard</span><span>AMEX</span><span>Discover</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copyright">
          &copy; 2026 Cewillow Market
        </div>
        <div className="footer-policies">
          <Link to="/terms" onClick={toTop}>
            Terms and Policies
          </Link>
        </div>
        <div className="footer-secure">Secure checkout · USD</div>
      </div>
    </footer>
  );
}

export default Footer;
